export default "__VITE_ASSET__yZEWKBnl__"